// app.routing.ts
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './App/login.component';
import { MySharedService } from './App/shared.service';
import { TimesheetComponent } from './Timesheet/timesheet.component';
import { AttendanceComponent } from './Attendance/attendance.component';
import { AttendanceMarkingComponent } from './AttendanceMarking/attendanceMarking.component';
import { GroupAttendanceComponent } from './AttendanceMarking/groupAttendance.component';
import { AttendanceReportComponent } from './AttendanceReport/attendanceReport.component';
import { UserMoodReportComponent } from './UserMoodReport/userMoodReport.component';
import { UsersComponent } from './Users/users.component';
import { CustomersComponent } from './Customers/customers.component';
import { SideMenuComponent } from './Layout/sideMenu.component';
import { TopheaderLayoutComponent } from './Layout/topHeaderLayout.component';
import { ChangePasswordComponent } from './App/changePassword.component';
import { ProjectListComponent } from './ProjectList/projectList.component';
import { ProjectsComponent } from './ProjectList/projects.component';
import { ProjectListReportComponent } from './ProjectListReport/projectListReport.component';
import { ProjectFinancialComponent } from './ProjectFinancial/projectFinancial.component';
import { ProjectFinancialReportComponent } from './ProjectFinancialReport/projectFinancialReport.component';
import { VendorsComponent } from './Vendors/vendors.component';
import { VendorsAddComponent } from './Vendors/vendorsAdd.component';
import { TeamComponent } from './Team/team.component';
import { ApplicationComponent } from './Application/application.component';
import { ParameterComponent } from './Parameter/parameter.component';
import { EditTimesheetComponent } from './Timesheet/editTimesheet.component';
import { AddTimesheetComponent } from './Timesheet/addTimesheet.component';
import { TaskTypeComponent } from './TaskType/taskType.component';
import { TaskGroupComponent } from './TaskGroup/taskGroup.component';
import { SiteMasterComponent } from './SiteMaster/siteMaster.component';
import { ShiftMasterComponent } from './ShiftMaster/shiftMaster.component';
import { TimesheetReportComponent } from './TimesheetReport/timesheetReport.component';
import { RosterComponent } from './Roster/roster.component';
import { HolidayComponent } from './Holiday/holiday.component';
import {SiteInfoComponent} from './SiteInfo/SiteInfo.component';
import {SiteInfoListComponent} from './SiteInfo/SiteInfoList.component';
import {ResourceGradeComponent} from './ResourceGrade/ResourceGrade.component';
import {ResourceCostComponent} from './ResourceGrade/ResourceCost.component';
import {ResourceGradeAndCostComponent} from './ResourceGrade/ResourceGradeAndCost.component';
import {ExecutiveDeploymentComponent} from './ExecutiveDeploymentReport/executiveDeploymentReport.component';
import {ProjectDeploymentReportComponent} from './ProjectDeploymentReport/projectDeploymentReport.component';
import {TeamDeploymentReportComponent} from './TeamDeploymentReport/teamDeploymentReport.component';
import {VendorEditComponent} from './Vendors/VendorEdit.component';
import {MyTaskComponent} from  './MyTask/MyTask.component';
import {MyTaskListComponent} from './MyTask/MyTaskList.component';
import {RatingComponent} from './Review/Rating.component';
import {PointComponent} from './Review/Point.component';
import {RatingReportSelfComponent } from './ReviewReport/ratingReportSelf.component';
import {RatingReportTeamComponent } from './ReviewReport/ratingReportTeam.component';
import {PointReportSelfComponent } from './ReviewReport/pointReportSelf.component';
import {PointReportTeamComponent } from './ReviewReport/pointReportTeam.component';
import {DetailedRatingReportTeamComponent} from './ReviewReport/detailedRatingReportTeam.component';
import {DetailedPointReportTeamComponent} from './ReviewReport/detailedPointReportTeam.component';
import {ReleaseLogsComponent } from './ReleaseLogs/releaselogs.component';
import {ReleaseLogsOutComponent } from './ReleaseLogs/releaselogsout.component';
import {BugTrackerListComponent } from './BugTracker/BugTrackerList.component';
import {BugTrackerComponent } from './BugTracker/BugTracker.component';
import {PowerbiComponent } from './powerbi/Powerbi.component';
import {ReviewEmployeeListComponent} from './ReviewEmployee/ReviewEmployeeList.component';
import {ReviewEmployeePrintComponent} from './ReviewEmployee/ReviewEmployeePrint.component';
import {SetupKRAComponent} from './ReviewEmployee/SetupKRA.component';
import {PeriodsComponent} from './Template/Periods.component';
import {TemplateComponent } from './Template/Template.component';
import {TemplateKRAComponent } from './Template/TemplateKRA.component';
import {ReviewSheetComponent} from './ReviewEmployee/ReviewSheet.component';
import {TimesheetAnalyzeComponent} from './TimesheetAnalyze/timesheetAnazlyze.component';
import {ProcessBillsComponent} from './ProcessBills/processBills.component';
import {TimesheetBillingComponent} from './TimesheetBilling/timesheetBilling.component';
import {ChangeRequestListComponent} from './ChangeRequest/ChangeRequestList.component';
import {ChangeRequestComponent} from './ChangeRequest/ChangeRequest.component';
import {InvoiceComponent} from './Invoice/Invoice.component';
import {InvoiceEditComponent} from './Invoice/InvoiceEdit.component';
import {InvoicePDFPrintComponent} from './Invoice/InvoicePDFPrint.component';
import {ChangeRequestLinkComponent} from './ChangeRequest/ChangeRequestLink.component';
import {ChangeRequestLinkThankYouComponent} from './ChangeRequest/ChangeRequestLinkThankYou.component';
import {CheckListComponent} from './MyTask/CheckList.component';
import {tablaeuReportComponent} from './tablaeu/tablaeuReport.component';
import {locationComponent} from './Location/location.component';
import {multiLocationTaskComponent} from './MultiLocationTask/multilocationtask.component';
import {multiLocationTaskFormsComponent} from './MultiLocationTask/multilocationtaskforms.component';
import {FileUploadComponent} from './FileUpload/FileUpload.component';
import {KeyValue} from './App/keyvalue.pipe';
import {clientViewComponent} from './ClientView/clientview.component';
import {vendorViewComponent} from './VendorView/vendorview.component';
import {MyTaskListCustomerComponent} from './MyTask/MyTaskListCustomer.component';
import {MyTaskCustomerComponent} from  './MyTask/MyTaskCustomer.component';
import {InstallationComponent} from  './Warranty/installation.component';
import {InstallationAddComponent} from  './Warranty/installationAdd.component';
import {InstallationAssetComponent} from  './Warranty/installationAsset.component';
import { PopupComponent } from './ReviewEmployee/PopUp.component';
import {TaskListComponent} from  './Task/TaskList.component';
import {TaskComponent} from './Task/Task.component';
import { WeeklyPlanComponent } from './WeeklyPlan/WeeklyPlan.component';
import { AppRenewalComponent } from './AppRenewal/appRenewal.component';
import { UploadComponent } from './Upload/upload.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'login', component: LoginComponent },
  { path: 'timesheet', component: TimesheetComponent },
  { path: 'attendance', component: AttendanceComponent },
  { path: 'attendanceMarking', component: AttendanceMarkingComponent },
  { path: 'attendanceReport', component: AttendanceReportComponent },
  { path: 'userMoodReport', component:UserMoodReportComponent },
  { path: 'users', component: UsersComponent },
  { path: 'customer', component: CustomersComponent },
  { path: 'changePassword', component: ChangePasswordComponent },
  { path: 'projectList', component: ProjectListComponent },
  { path: 'projects', component: ProjectsComponent },
  { path: 'groupAttendance', component: GroupAttendanceComponent },
  { path: 'projectListReport', component: ProjectListReportComponent },
  { path: 'projectFinancial', component: ProjectFinancialComponent },
  { path: 'projectFinancialReport', component: ProjectFinancialReportComponent },
  { path: 'vendors', component: VendorsComponent },
  { path: 'vendorsAdd', component: VendorsAddComponent },
  { path: 'team', component: TeamComponent },
  { path: 'application', component: ApplicationComponent },
  { path: 'releaselogs', component: ReleaseLogsComponent },
  { path: 'parameter', component: ParameterComponent },
  { path: 'editTimesheet', component: EditTimesheetComponent },
  { path: 'addTimesheet', component: AddTimesheetComponent },
  { path: 'taskType', component: TaskTypeComponent },
  { path: 'taskGroup', component: TaskGroupComponent },
  { path: 'siteMaster', component: SiteMasterComponent },
  { path: 'timesheetReport', component: TimesheetReportComponent },
  { path: 'shiftMaster', component: ShiftMasterComponent },
  { path: 'roster', component: RosterComponent },
  { path: 'holiday', component: HolidayComponent },
  { path: 'siteInfo',component: SiteInfoComponent},
  { path: 'siteInfoList',component: SiteInfoListComponent},
  { path: 'resourceGrade',component: ResourceGradeAndCostComponent},
  { path: 'resourceCost',component: ResourceCostComponent},
  { path: 'resourceGradeAndCost',component: ResourceGradeAndCostComponent},
  { path: 'executiveDeployment',component: ExecutiveDeploymentComponent},
  { path: 'projectDeployment',component: ProjectDeploymentReportComponent},
  { path: 'teamDeployment',component:TeamDeploymentReportComponent},
  { path: 'vendorEdit',component:VendorEditComponent},
  { path:'MyTaskList',component:MyTaskComponent},
  { path: 'MyTask',component:MyTaskListComponent},
  { path: 'rating',component:RatingComponent},
  { path: 'point',component:PointComponent},
  { path: 'ratingReportSelf',component:RatingReportSelfComponent},
  { path: 'ratingReportTeam',component:RatingReportTeamComponent},
  { path: 'pointReportSelf',component:PointReportSelfComponent},
  { path: 'pointReportTeam',component:PointReportTeamComponent},
  { path: 'detailedRatingReport',component:DetailedRatingReportTeamComponent},
  { path: 'detailedPointReport',component:DetailedPointReportTeamComponent},
  { path: 'releaselogsout', component: ReleaseLogsOutComponent },
  { path: 'bugTracker', component: BugTrackerListComponent },
  { path: 'bugTrackerEdit', component: BugTrackerComponent },
  { path: 'powerbiReport', component: PowerbiComponent },
  { path:'reviewEmployeeList', component: ReviewEmployeeListComponent},
  { path: 'setupKRA', component: SetupKRAComponent},
  { path: 'ReviewEmployeePrint', component: ReviewEmployeePrintComponent},
  { path:'ReviewPeriod',component:PeriodsComponent},
  { path: 'Template', component: TemplateComponent},
  { path: 'TemplateKRA', component: TemplateKRAComponent},
  { path: 'reviewSheet', component: ReviewSheetComponent},
  { path: 'timesheetAnalyze', component: TimesheetAnalyzeComponent},
  { path: 'processBills', component: ProcessBillsComponent},
  { path: 'timesheetBilling', component: TimesheetBillingComponent},
  { path: 'ChangeRequest', component: ChangeRequestComponent},
  { path: 'ChangeRequestList', component: ChangeRequestListComponent},
  { path: 'invoice', component: InvoiceComponent},
  { path: 'invoiceEdit', component: InvoiceEditComponent},
  { path: 'invoicePrint', component: InvoicePDFPrintComponent},
  { path: 'ChangeRequestLink', component: ChangeRequestLinkComponent},
  { path: 'ChangeRequestLinkThankYou', component: ChangeRequestLinkThankYouComponent},
  { path: 'CheckList', component: CheckListComponent},
  { path: 'tableauReport',component: tablaeuReportComponent},
  { path: 'location', component: locationComponent},
  { path: 'multiLocationTask', component: multiLocationTaskComponent},
  { path: 'multiLocationTaskForms', component: multiLocationTaskFormsComponent},
  { path: 'fileUpload', component: FileUploadComponent},
  { path: 'vendorView', component: vendorViewComponent},
  { path: 'clientView', component: clientViewComponent},
  { path: 'MyTaskCustomer',component: MyTaskListCustomerComponent},
  { path: 'MyTaskListCustomer',component: MyTaskCustomerComponent},
  { path: 'installation',component: InstallationComponent},
  { path: 'installationAdd',component: InstallationAddComponent},
  { path: 'installationAsset',component: InstallationAssetComponent},
  { path:'tasks',component:TaskComponent},
  { path: 'taskList',component:TaskListComponent},
  { path: 'WeeklyPlan', component:WeeklyPlanComponent },
  { path: 'appRenewal', component: AppRenewalComponent },
   { path: 'upload', component: UploadComponent },
  { path: '**', redirectTo: 'login' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

export const routingComponents = [
  LoginComponent,
  ChangePasswordComponent,
  TimesheetComponent,
  AttendanceComponent,
  AttendanceMarkingComponent,
  GroupAttendanceComponent,
  AttendanceReportComponent,
  UserMoodReportComponent,
  UsersComponent,
  PopupComponent,
  CustomersComponent,
  SideMenuComponent,
  TopheaderLayoutComponent,
  ProjectListComponent,
  ProjectsComponent,
  ProjectListReportComponent,
  ProjectFinancialComponent,
  ProjectFinancialReportComponent,
  VendorsComponent,
  VendorsAddComponent,
  TeamComponent,
  ApplicationComponent,
  ParameterComponent,
  EditTimesheetComponent,
  AddTimesheetComponent,
  TaskTypeComponent,
  TaskGroupComponent,
  SiteMasterComponent,
  TimesheetReportComponent,
  ShiftMasterComponent,
  RosterComponent,
  SiteInfoComponent,
  SiteInfoListComponent,
  ResourceGradeComponent,
  ResourceCostComponent,
  ResourceGradeAndCostComponent,
  ExecutiveDeploymentComponent,
  ProjectDeploymentReportComponent,
  TeamDeploymentReportComponent,
  HolidayComponent,
  VendorEditComponent,
  MyTaskComponent,
  MyTaskListComponent,
  RatingComponent,
  PointComponent,
  RatingReportSelfComponent,
  RatingReportTeamComponent,
  PointReportSelfComponent,
  PointReportTeamComponent,
  DetailedRatingReportTeamComponent,
  DetailedPointReportTeamComponent,
  ReleaseLogsComponent,
  ReleaseLogsOutComponent,
  BugTrackerListComponent,
  BugTrackerComponent,
  PowerbiComponent,
  ReviewEmployeeListComponent,
  SetupKRAComponent,
  ReviewEmployeePrintComponent,
  PeriodsComponent,
  TemplateComponent,
  TemplateKRAComponent,
  ReviewSheetComponent,
  TimesheetAnalyzeComponent,
  ProcessBillsComponent,
  TimesheetBillingComponent,
  ChangeRequestComponent,
  ChangeRequestListComponent,
  InvoiceComponent,
  InvoiceEditComponent,
  InvoicePDFPrintComponent,
  ChangeRequestLinkComponent,
  ChangeRequestLinkThankYouComponent,
  CheckListComponent,
  tablaeuReportComponent,
  locationComponent,
  multiLocationTaskComponent,
  multiLocationTaskFormsComponent,
  FileUploadComponent,
  KeyValue,
  vendorViewComponent,
  clientViewComponent,
  MyTaskListCustomerComponent,
  MyTaskCustomerComponent,
  InstallationComponent,
  InstallationAddComponent,
  InstallationAssetComponent,
  TaskComponent,
  TaskListComponent,
  WeeklyPlanComponent,
  AppRenewalComponent,
  UploadComponent
];


/** WEBPACK FOOTER **
 ** ./TypeScripts/app.routing.ts
 **/